'use strict';

// Declare app level module which depends on views, and components
var rmOBA = angular.module('rmOBA', [
  'ngRoute',
  'ngMessages',
  'ngSanitize',
  'ui.select',
  'ngCsv',
  'ngCookies',
  'mgcrea.ngStrap',
  'rmOBA.01PostingDetails',
  'rmOBA.02OrderDetails',
  'rmOBA.03EmailPrint',
  'rmOBA.printManifest',
  'rmOBA.styleguide'
]).
config(['$routeProvider', function($routeProvider) {
  $routeProvider.otherwise({redirectTo: '/'});
}])
.run(function($rootScope, $document) {

  $rootScope.isUnsupported = function() {
      var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      // check for Safari desktop:
      var isSafari = (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1 && !iOS);
      if (isSafari) {
        return true;
      }
  }

  $rootScope.isMobile = function() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Silk/i.test(navigator.userAgent)) {
        return true;
      }
  }
  
});
